import { clone } from './clone';
import {
  Docket,
  DocketEventInput,
  DocketPayloadInput,
} from '@oolio-group/domain';

export const processDocketItem = (
  event: DocketEventInput,
  prevState: Docket,
) => {
  if (!event?.payload) return;
  const docket = clone(prevState);
  const docketItem = {
    orderId: event.payload.orgId,
    printerProfileId: event.payload.printerProfileId,
    id: event.payload.id,
    orgId: event.payload.orgId,
    storeId: event.payload.storeId,
    venueId: event.payload.venueId,
    orderItemId: event.payload.orderItemId,
    docketId: event.payload.docketId,
    notes: event.payload.notes,
    status: event.payload.status,
    createdAt: event.payload.createdAt,
    product: event.payload.product,
    quantity: event.payload.quantity,
    variant: event.payload.variant,
    modifiers: event.payload.modifiers,
    optionValues: event.payload.optionValues,
    course: event.payload.course,
    comboItems: event.payload.comboItems,
  };
  // TODO: to fix events which will break due to void not being handled
  docket.docketItems.push(docketItem as DocketPayloadInput);
  return docket;
};
